var project, platform, vm
export default class LineLiff {

    // 預載功能
    constructor(_vm) {
        vm = this
        project = _vm
    }

    /**
     * 初始化 Line Liff SDK
     */
    async loadSDK (_myLiffId, _needLogin = false) {
        console.log('')
        console.log('===================')
        console.log('--> 開始載入 Liff 應用程式...')

        await window.liff
            .init({
                liffId: _myLiffId
            })
            .then(async () => {
                project.apis.sendLogToSlack(
                    'Liff 應用程序載入成功...' + "\r\n" +
                    'RUN OS: ' + window.liff.getOS() + "\r\n" +
                    'RUN Language: ' + window.liff.getLanguage() + "\r\n" +
                    'RUN IN LINE: ' + window.liff.isInClient() + "\r\n" +
                    'User Login Status: ' + window.liff.isLoggedIn()
                )

                // 設置參數
                platform = {}
                platform.os = window.liff.getOS()
                platform.liffId = _myLiffId
                platform.language = window.liff.getLanguage()
                platform.isInClient = window.liff.isInClient()
                platform.isLoggedIn = window.liff.isLoggedIn()
                platform.runLineVer = window.liff.getLineVersion()
                project.platform = platform

                project.apis.sendLogToSlack('Line Liff 初始化完成, Login Status: [' + platform.isLoggedIn + '], RUN IN LINE: [' + platform.isInClient + '], RUN LINE VERSION: [' + platform.runLineVer + ']')

                if (process.env.VUE_APP_NODE === 'dev') {
                    console.log('--> 啟用開發模式...')
                    return true
                }

                // 當驗證為啟動 Liff 應用程序時
                let redirectUri
                if (_myLiffId === '1656948354-wMYqkgzM') {
                    redirectUri = "https://wb.didifun.club/wb/1656948354-wMYqkgzM/register"
                }
                if (_myLiffId === '1656948354-awyhbIzH') {
                    redirectUri = "https://wb.didifun.club/wb/1656948354-awyhbIzH/register"
                }
                if (_myLiffId === '1656948354-Ld4JxjN9') {
                    redirectUri = "https://wb.didifun.club/wb/1656948354-Ld4JxjN9/member"
                }
                if (_myLiffId === '1656948354-CKEAoQTd') {
                    redirectUri = "https://wb.didifun.club/wb/1656948354-CKEAoQTd/member"
                }
                console.log('redirectUri: ', redirectUri)

                if (_needLogin && !platform.isLoggedIn) {
                    return window.liff.login({ redirectUri: redirectUri })
                }

                // 嘗試獲取 Line User Profile
                setTimeout(() => { vm.getUserProfile() }, 500);

            }).catch((err) => {
                project.apis.sendLogToSlack('LIFF INIT ERROR: ' + err)
            })
    }

    /**
     * 嘗試獲得用戶資料
     */
    async getUserProfile () {
        await window.liff.getProfile()
            .then(async profile => {
                // 設置 Line User ID
                project.user = profile
                // 請求處理用戶資料
                project.processUserData()
                // 回報獲取的資訊
                project.apis.sendLogToSlack('User Profile: ' + JSON.stringify(profile))
            })
            .catch((err) => {
                project.apis.sendLogToSlack('Line Get User Profile Error: ' + err)
            })
    }
}